"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.Cards = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _Banner = _interopRequireDefault(require("../Banner"));

var _Cards = require("./Cards.style");

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var _Carousel = _interopRequireDefault(require("../Carousel"));

var _cardsRenderer = _interopRequireDefault(require("./cardsRenderer"));

var Cards = function Cards(_ref) {
  var banner = _ref.banner,
      cards = _ref.cards,
      cardsPerRow = _ref.cardsPerRow,
      cta = _ref.cta,
      display = _ref.display,
      id = _ref.id,
      subtitle = _ref.subtitle,
      title = _ref.title,
      variant = _ref.variant,
      cardWidthOverride = _ref.cardWidthOverride,
      itemsToShow = _ref.itemsToShow,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["banner", "cards", "cardsPerRow", "cta", "display", "id", "subtitle", "title", "variant", "cardWidthOverride", "itemsToShow", "children"]);

  var _ref2 = (0, _react.useState)(itemsToShow ? itemsToShow > 0 : false),
      _ref3 = _slicedToArray(_ref2, 2),
      isFilterApplied = _ref3[0],
      setIsFilterApplied = _ref3[1];

  var hasSubtitle = !!subtitle;
  var hasBanner = !!banner;
  var cardWidth = [2, 3, 4].includes(cardsPerRow) ? 12 / cardsPerRow : 4;
  var responsiveCardWidth = cardWidthOverride || (variant === 'list' ? [12] : [12, 12, 6, 6, cardWidth]);

  var getCardsToShow = function getCardsToShow() {
    if (!isFilterApplied) {
      return cards;
    }

    return itemsToShow ? cards === null || cards === void 0 ? void 0 : cards.slice(0, itemsToShow) : cards;
  };

  var renderCards = function renderCards(inCarousel) {
    return cards && getCardsToShow().map(function (card, index) {
      var key = card.key || "".concat(card.title, "_").concat(index);
      return /*#__PURE__*/_react.default.createElement(_Layout.Column, {
        key: key,
        width: responsiveCardWidth,
        inCarousel: inCarousel
      }, (0, _cardsRenderer.default)(card, variant, cardsPerRow));
    });
  };

  var enoughCards = cards && (variant === 'profile' && cards.length > 4 || variant !== 'profile' && cards.length > 3);
  var showCta = cta && (display !== 'carousel' || display === 'carousel' && enoughCards) && !itemsToShow;
  var carouselCardsToShow = variant === 'profile' ? 4 : 3;
  var gridItemsAlignment = variant === 'profile' ? 'stretch' : 'flex-end';
  return /*#__PURE__*/_react.default.createElement(_Layout.Container, Object.assign({}, rest, {
    id: id
  }), title && /*#__PURE__*/_react.default.createElement(_Cards.CardsTitleWrap, {
    hasSubtitle: hasSubtitle,
    hasBanner: hasBanner
  }, /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, null, title), showCta && /*#__PURE__*/_react.default.createElement(_Cards.CardsButton, Object.assign({
    endIcon: "ChevronRight",
    size: "small",
    variant: "link"
  }, cta), cta.label)), banner && /*#__PURE__*/_react.default.createElement(_rebass.Box, {
    mb: "large"
  }, /*#__PURE__*/_react.default.createElement(_Banner.default, banner)), subtitle && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    mb: "large",
    as: "div",
    size: "small"
  }, subtitle), display === 'carousel' && enoughCards && variant !== 'list' ? /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    slidesToShow: carouselCardsToShow,
    responsive: [1, 2, 2],
    variant: variant
  }, children || renderCards(true)) : /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    alignItems: gridItemsAlignment
  }, children || renderCards()), isFilterApplied && /*#__PURE__*/_react.default.createElement(_Cards.CardsFooterWrap, null, /*#__PURE__*/_react.default.createElement(_Cards.CardsButton, {
    size: "large",
    variant: "primary",
    onClick: function onClick() {
      setIsFilterApplied(false);

      if (cta && typeof cta.onClick === 'function') {
        cta.onClick();
      }
    }
  }, (cta === null || cta === void 0 ? void 0 : cta.label) || 'Show more')));
};

exports.Cards = Cards;
Cards.propTypes = {
  /** Pass Children instead of list of cards if you want to control logic of each card. It overrides the cards props */
  children: _propTypes.default.node,

  /** Props for the cards. Pass an empty array if you provide children */
  cards: _propTypes.default.arrayOf(Object).isRequired,

  /** Number of cards shown on desktop. choose between 2,3,4 */
  cardsPerRow: _propTypes.default.oneOf([2, 3, 4]),
  cardWidthOverride: _propTypes.default.arrayOf(_propTypes.default.number),
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    onClick: function onClick() {}
  }),
  display: _propTypes.default.oneOf(['carousel', 'grid']),
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['article', 'list', 'product', 'profile', 'detailedProfile', 'signpost', 'signpostText']),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  itemsToShow: _propTypes.default.number
};
Cards.defaultProps = {
  children: null,
  cardsPerRow: 3,
  cardWidthOverride: null,
  cta: null,
  display: 'grid',
  id: null,
  title: null,
  subtitle: null,
  variant: 'product',
  banner: null,
  itemsToShow: null
};
var _default = Cards;
exports.default = _default;